import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import {
  IconButton
} from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const ThumbnailNavControls = ({ classes, mappedImagesLength, visibleDistanceFromCenter, thumbnailIndex, setThumbnailIndex }) => {
  function handleNextThumbnail() {
    const nextIndex = thumbnailIndex + 1;
    setThumbnailIndex(nextIndex);
  }
  function handlePrevThumbnail() {
    const prevIndex = thumbnailIndex - 1;
    setThumbnailIndex(prevIndex);
  }

  return (
    <div className={classNames(classes.buttonContainer, classes.thumbnailButtonContainer)}>
      <IconButton
        onClick={thumbnailIndex - visibleDistanceFromCenter - 1 < 0 ? () =>{} : () => handlePrevThumbnail()}
        classes={{
          root: classNames(classes.icon, classes.iconThumbnailScroll),
          disabled: classes.iconThumbnailScrollDisabled
        }}
        disabled={thumbnailIndex - visibleDistanceFromCenter - 1 < 0}
      >
        <ChevronLeftIcon />
      </IconButton>
      <IconButton
        onClick={() => handleNextThumbnail()}
        classes={{
          root: classNames(classes.icon, classes.iconThumbnailScroll),
          disabled: classes.iconThumbnailScrollDisabled
        }}
        disabled={thumbnailIndex + visibleDistanceFromCenter + 1 > mappedImagesLength - 1}
      >
        <ChevronRightIcon />
      </IconButton>
    </div>
  );
}

const styles = theme => ({
  buttonContainer: {
    position: 'absolute',
    height: '48px',
    width: '100%',
    // top: 'calc(50% - 24px)', // centered to whole dialog
    top: 'calc(50% - 92px)', // centered to image section only (exclude thumbnails)
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  icon: {
    color: '#fff',
    background: '#333333a8',

    '&:hover': {
      background: '#333333db'
    },
    margin: 4
  },
  iconThumbnailScroll: {
    zIndex: 1,
    padding: '56px 8px',
    borderRadius: 0,
    margin: 0
  },
  iconThumbnailScrollDisabled: {
    color: '#ffffff42!important',
    backgroundColor: '#333333a8!important'
  },
  thumbnailButtonContainer: {
    top: 'calc(100% - 92px)'
  }
});

export default withStyles(styles)(ThumbnailNavControls);